import { Text } from 'grommet'
import styled from 'styled-components'

const ItalicText = styled(Text)`
  font-style: italic;
`

export default ItalicText